import { absoluteUrl, buildAlternateUrls } from './urls';
import { DEFAULT_OG_IMAGE, SITE_NAME, SITE_NAME_FA } from './config';

const brandSuffix = (language) => (language === 'fa' ? SITE_NAME_FA : SITE_NAME);

export const getHomeMetadata = (language) => {
  const isFa = language === 'fa';

  return {
    title: isFa
      ? 'ریسمان | ساخت محصول با هوش مصنوعی و AI'
      : 'Risman | AI Product Builder — Apps, Websites & MVPs',
    description: isFa
      ? 'ریسمان به شما کمک می‌کند ایده‌ها را با هوش مصنوعی به محصولات واقعی تبدیل کنید: SaaS، فروشگاه آنلاین، لندینگ، بلاگ، ابزار داخلی و MVP — با پیش‌نمایش زنده و استقرار فوری.'
      : 'Risman turns ideas into real products with AI. Build SaaS apps, online shops, landing pages, blogs, internal tools, and MVPs with live preview and instant deployment.',
    keywords: isFa
      ? 'ساخت محصول با هوش مصنوعی, ساخت اپلیکیشن با هوش مصنوعی, ساخت سایت با هوش مصنوعی, ساخت MVP با هوش مصنوعی, ساخت SaaS با هوش مصنوعی'
      : 'AI product builder, AI app builder, AI website builder, AI MVP generator, no-code SaaS builder, AI development platform',
    pathname: '/',
    robots: 'index,follow,max-image-preview:large',
    ogType: 'website'
  };
};

export const getAboutMetadata = (language) => {
  const isFa = language === 'fa';

  return {
    title: isFa
      ? `درباره ${brandSuffix(language)} | پلتفرم ساخت محصول با AI`
      : `About ${brandSuffix(language)} | AI Product Development Platform`,
    description: isFa
      ? 'ریسمان پلتفرمی برای تبدیل ایده به محصول است: پیش‌نمایش زنده، استقرار فوری، دامنه اختصاصی، یکپارچگی Supabase و درگاه پرداخت — بدون کدنویسی سنگین.'
      : 'Learn how Risman helps founders and teams turn ideas into launch-ready products with live sandbox preview, instant deployment, custom domains, Supabase, and payment integrations.',
    keywords: isFa
      ? 'درباره ریسمان, ساخت محصول با هوش مصنوعی, پلتفرم ساخت SaaS'
      : 'about Risman, AI product builder, no-code SaaS platform',
    pathname: '/about',
    robots: 'index,follow',
    ogType: 'website'
  };
};

export const getPricingMetadata = (language) => {
  const isFa = language === 'fa';

  return {
    title: isFa
      ? `تعرفه ${brandSuffix(language)} | قیمت مدل‌های AI و امکانات پلتفرم`
      : `${brandSuffix(language)} Pricing | AI Model and Platform Costs`,
    description: isFa
      ? 'تعرفه شفاف ریسمان: قیمت مدل‌های هوش مصنوعی به ازای هر میلیون توکن و هزینه انتشار و مدیریت کاربران برای پروژه‌های منتشرشده.'
      : 'Transparent Risman pricing: AI model costs per million tokens plus publishing and user management fees for published projects.',
    keywords: isFa
      ? 'تعرفه ریسمان, قیمت ساخت محصول با هوش مصنوعی, قیمت مدل AI, هزینه انتشار ریسمان'
      : 'Risman pricing, AI product builder pricing, AI model pricing, Risman deployment cost',
    pathname: '/pricing',
    robots: 'index,follow',
    ogType: 'website'
  };
};

export const resolvePageMetadata = ({ page, language }) => {
  let metadata;

  switch (page) {
    case 'home':
      metadata = getHomeMetadata(language);
      break;
    case 'about':
      metadata = getAboutMetadata(language);
      break;
    case 'pricing':
      metadata = getPricingMetadata(language);
      break;
    default:
      return null;
  }

  if (!metadata) {
    return null;
  }

  const alternates = buildAlternateUrls(metadata.pathname);
  const canonical = absoluteUrl(metadata.pathname, language);

  return {
    ...metadata,
    language,
    canonical,
    alternates,
    ogImage: DEFAULT_OG_IMAGE,
    twitterCard: 'summary_large_image',
    siteName: language === 'fa' ? SITE_NAME_FA : SITE_NAME
  };
};

export const getAllPublicMetadataEntries = () => {
  const languages = ['en', 'fa'];
  const staticPages = ['home', 'about', 'pricing'];
  const entries = [];

  languages.forEach((language) => {
    staticPages.forEach((page) => {
      const metadata = resolvePageMetadata({ page, language });
      if (metadata) {
        entries.push(metadata);
      }
    });
  });

  return entries;
};
